module.exports = __webpack_public_path__ + "static/img/phyto-res.87dcb530.jpeg";